import React from "react"
import style from "./style.module.sass"
import HIXWrapperAi from "./HIXWrapperAi"
import FLESCHWrapperAi from "./FLESCHWrapperAi"
import { useSelector } from "react-redux"
import CLIXWrapperAi from "./CLIXWrapperAi"
import { roundWithPrecision } from "../../../../utils"
import config from "../../../../config"

export default function TopIndicatorsBarAi({
  extResultData = undefined,
  extCurrentBenchmarkSettings = undefined,
  gen = false,
  ai = false,
  left = false
}) {

  const reduxResultData = useSelector(
    (state) => state.analyseData.result.resultData
  )
  const resultData = extResultData ? extResultData : reduxResultData

  const reduxCurrentBenchmarkSettings = useSelector(
    (state) => state.analyseData.result.benchmark
  )
  const tabIndexes = config.tabIndexes
  const tabIndexHIX = gen ? tabIndexes.genHixWrapper : left ? tabIndexes.aiHixWrapperLeft : tabIndexes.aiHixWrapperRight
  const tabIndexFLESCH = gen ? tabIndexes.genFleschWrapper : left ? tabIndexes.aiFleschWrapperLeft : tabIndexes.aiFleschWrapperRight
  const tabIndexCLIX = gen ? tabIndexes.genClixWrapper : left ? tabIndexes.aiClixWrapperLeft : tabIndexes.aiClixWrapperRight
  const currentBenchmarkSettings = extCurrentBenchmarkSettings
    ? extCurrentBenchmarkSettings
    : reduxCurrentBenchmarkSettings

  const targetHix =
    currentBenchmarkSettings?.settings?.formulaHix?.values?.target || 0
  const targetFlesch =
    currentBenchmarkSettings?.settings?.formulaFlesch?.values?.target || 0
  const targetCLIX =
    currentBenchmarkSettings?.settings?.formulaCLIX?.values?.target || 0

  return (
    <div className={`${style.mainCont}`}>
      <div className={`d-flex ${style.barsCont}`} style={{gridGap: ai ? "7px" : "15px"}} >
        {resultData["formulaHix"] !== undefined ? (
          <HIXWrapperAi
            hix={roundWithPrecision(resultData.formulaHix, 2)}
            target={targetHix} tabIndex={tabIndexHIX}
          />
        ) : (
          resultData["formulaFlesch"] !== undefined && (
            <FLESCHWrapperAi
              flesch={roundWithPrecision(resultData.formulaFlesch, 2)}
              target={targetFlesch} tabIndex={tabIndexFLESCH}
            />
          )
        )}
        {resultData["formulaCLIX"] !== undefined && (
          <CLIXWrapperAi
            clix={roundWithPrecision(resultData.formulaCLIX, 2)}
            target={targetCLIX} tabIndex={tabIndexCLIX}
          />
        )}
      </div>
    </div>
  )
}